import type { RouteLocationRaw } from 'vue-router'

/**
 * Canonical in-app routes for a company (tickets/2854).
 *
 * Replaces the legacy `rails_url() + '/companies/:id'` builders — Rails now
 * only 302s those back into the SPA (tickets/2582), so every hand-built URL
 * cost a full-page bounce. All SPA surfaces (portfolio tables, distribution
 * details, overview cards) link through here so company URLs have one shape.
 *
 * Rails-only pages (cap table, distributions) intentionally keep their
 * rails_url links.
 */
export const companyProfileRoute = (slug: string, companyId: string | number): RouteLocationRaw => ({
  name: 'companies.profile',
  params: { slug, companyId: String(companyId) },
})

/** Company Investments page (Holdings/Transactions) — where the legacy
 *  term-sheet pages' capabilities now live (tickets/2888). */
export const companyActivityRoute = (slug: string, companyId: string | number): RouteLocationRaw => ({
  name: 'companies.activity',
  params: { slug, companyId: String(companyId) },
})
